module.exports = __webpack_public_path__ + "static/media/nrna_mbl.39ce3148.png";